import * as React from 'react';
import { makeIcon } from './makeIcon';
const ViewList = props => (React.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M0,3 L0,4.57142857 L16,4.57142857 L16,3 L0,3 Z M0,7.71428571 L0,9.28571429 L16,9.28571429 L16,7.71428571 L0,7.71428571 Z M0,12.4285714 L0,14 L16,14 L16,12.4285714 L0,12.4285714 Z" })));
export const ViewListIcon = makeIcon('viewList')(ViewList);
//# sourceMappingURL=ViewList.js.map